const TdEnd = ({ children }) => (
  <div className="fw-bold text-end">{children}</div>
)

export { TdEnd }